import { render, staticRenderFns } from "./swipeLeft.vue?vue&type=template&id=34165d30&scoped=true&"
import script from "./swipeLeft.vue?vue&type=script&lang=js&"
export * from "./swipeLeft.vue?vue&type=script&lang=js&"
import style0 from "./swipeLeft.vue?vue&type=style&index=0&id=34165d30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34165d30",
  null
  
)

export default component.exports